
<template>
    <div>
    
        <h3>Find by Category</h3>
    
        <ul class="list-unstyled flyout-nav mb-4">
            <li v-for="menuItem in this.$store.state.dynamicRoutes.leftMenuTop">
                <a href="#" @blur="dismissMenu(menuItem.id)" @click.prevent="toggleMenu(menuItem.id)">{{ menuItem.title }}  <span><i class="fa fa-chevron-right"></i></span></a>
                
                <ul v-if="menuItem.subcats.length!=0" class="condensedMenu" :data-length="menuItem.subcats.length" v-show="menuState[menuItem.id]">
                    <template v-for="(products, name) in menuItem.subcats">
                        <span class="d-block pl-2"><strong>{{ name }}</strong></span>
                        <li v-for="submenuItem in products">
                            <router-link :to="submenuItem.path">{{ submenuItem.title }}<em v-if="submenuItem.product_type"> - {{ submenuItem.product_type }}</em>
                            </router-link>
                        </li>
                    </template>
                </ul>
            </li>
            
        </ul>

        <!-- <h3>Find by Service</h3>

        <ul class="list-unstyled flyout-nav">
            <li v-for="menuItem in this.$store.state.dynamicRoutes.leftMenuBottom">
                <a href="#">{{ menuItem.title }}  <span><i class="fa fa-chevron-right"></i></span></a>
                <ul v-if="menuItem.subcats">
                    <li v-for="submenuItem in menuItem.subcats">
                        <router-link :to="submenuItem.path">{{ submenuItem.title }}</router-link>
                    </li>
                </ul>
            </li>
    
        </ul> -->
    </div>
</template>

<script>
export default {
    name: "left-menu",
    data() {
        return { menuState : {} };
    },
    methods: {
        toggleMenu : function (menuID) {
            let index = Object.keys(this.menuState).find(key => this.menuState[key] == 1 && menuID !=key );
            if(index) this.$set(this.menuState, index, 0);
            this.$set(this.menuState, menuID, this.menuState[menuID] == 1 ? 0: 1);
        },
        dismissMenu: function(menuID){
            setTimeout(() => { this.$set(this.menuState, menuID, 0); }, 600);
        }
    }
};
</script>

